import BigNumber from "bignumber.js";
import { useQuery } from "react-query";

import { checkCurrentBalanceApi } from "../../../../../api/merchant";
import { displayAmount } from "../../../../../utils/helper";
import { useZusDialogStore } from "../../../../../zustand/store";
import { getCommonDisplayDecimals } from "../../helpers/getCommonDisplayDecimals";

interface IProps {
  chainType: number;
  chainId: number;
  assetName: string;
  decimals: string;
  walletAddress: string;
  balance: any;
  updateBalance: (balance: string) => void;
}

const Balance = (props: IProps) => {
  const {
    chainType,
    chainId,
    assetName,
    decimals,
    walletAddress,
    balance,
    updateBalance,
  } = props;

  const zusDialog = useZusDialogStore();

  const isEnable = Boolean(
    chainType && chainId && assetName && decimals && walletAddress
  );

  useQuery({
    queryKey: [
      "balance",
      chainType,
      chainId,
      assetName,
      decimals,
      walletAddress,
    ],
    queryFn: async () => {
      zusDialog.openExtra("loadingDialog");
      const res = await checkCurrentBalanceApi({
        chain_type: chainType,
        chain_id: chainId,
        asset_name: assetName,
        decimals: decimals,
        wallet_address: walletAddress,
      });
      zusDialog.closeExtra();

      return res;
    },
    onSuccess: (data) => {
      if (!data?.balance && data?.balance !== "0") {
        return updateBalance("");
      }

      const balanceDisplay = BigNumber(data?.balance)
        .dividedBy(Math.pow(10, Number(decimals)))
        .decimalPlaces(getCommonDisplayDecimals(Number(decimals)), 1)
        .toFixed()
        .toString();

      if (!balanceDisplay && balanceDisplay !== "0") {
        return updateBalance("");
      }

      updateBalance(balanceDisplay);
    },
    enabled: isEnable,
  });

  return (
    <div>
      {balance || balance === "0"
        ? `${displayAmount(balance, 0)} ${assetName || ""}`
        : "-"}
    </div>
  );
};

export default Balance;
